<template>
  <div id="forceLsWrapper" :style="needTransform ? forceLsStyle : normalStyle">
    <slot name="default"> </slot>
  </div>
</template>

<script>
import { DEVICE_TYPE } from "@/constant";

/**
 * 若强制横屏，本组件将通过自身旋转90度，将slot内的内容变为横屏，主要依靠以下css：
 * position:absolute;transform:rotate(90deg);width:100vh;height:100vw;top:140px;left:-140px;
 * top和left是根据第一个child的坐标进行整体平移.
 */

export default {
  name: "ForceLandscape",
  props: {
    forceLandscape: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curHeight: window.innerHeight,
      normalStyle: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "-webkit-fill-available",
        height: `${window.innerHeight}px`,
      },
      forceLsStyle: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        "z-index": 3,
        width: `${window.innerHeight}px`,
        height: `${window.innerWidth}px`,
        top: 0,
        left: `${window.innerWidth}px`,
        "-webkit-transform": "rotate(90deg)",
        "-moz-transform": "rotate(90deg)",
        "-ms-transform": "rotate(90deg)",
        transform: "rotate(90deg)",
        "transform-origin": "0% 0%",
      },
      ori: null,
      transTop: 0,
      transLeft: 0,
      needTransform1: true,
    };
  },
  computed: {
    /** 只有竖屏且强制横屏时才需要旋转 */
    needTransform() {
      return (
        this.forceLandscape && this.ori == "Portrait" && DEVICE_TYPE.isMobile
      );
    },
  },
  watch: {
    forceLandscape(newVal, oldVal) {
      this.ori =
        window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
      console.log("forceLandscape----", newVal);
      this.$nextTick(() => {
        this.needTransform1 =
          newVal && this.ori == "Portrait" && DEVICE_TYPE.isMobile;
      });
    },
  },
  methods: {
    handleLandscape() {
      // console.log("init forcelandscape");
      this.curHeight = window.innerHeight;
      if (!this.forceLandscape) return;
      else {
        this.ori =
          window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
      }
      // 移动端&&游戏横屏&&当前竖屏，才需要旋转
      this.needTransform1 =
        this.forceLandscape && this.ori == "Portrait" && DEVICE_TYPE.isMobile;
      this.normalStyle = JSON.parse(
        JSON.stringify({
          position: "fixed",
          top: 0,
          left: 0,
          width: "-webkit-fill-available",
          height: `${window.innerHeight}px`,
        })
      );
      this.forceLsStyle = {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        "z-index": 3,
        width: `${window.innerHeight}px`,
        height: `${window.innerWidth}px`,
        left: `${window.innerWidth}px`,
        "-webkit-transform": "rotate(90deg)",
        "-moz-transform": "rotate(90deg)",
        "-ms-transform": "rotate(90deg)",
        transform: "rotate(90deg)",
        "transform-origin": "0% 0%",
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleLandscape); // 监听resize来判断是否是横屏/竖屏
    window.addEventListener("orientationchange", this.handleLandscape);

    this.handleLandscape();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleLandscape);
    window.removeEventListener("orientationchange", this.handleLandscape);
  },
};
</script>

<style>
</style>